var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#48464E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4318 7C14.8578 7 13.3481 7.6253 12.2351 8.73834C11.1221 9.85138 10.4968 11.361 10.4968 12.9351V15.9838L8.79121 17.6894C8.41334 18.0677 8.15605 18.5495 8.05186 19.0739C7.94766 19.5984 8.00123 20.142 8.20579 20.636C8.41036 21.13 8.75674 21.5523 9.20119 21.8496C9.64564 22.1469 10.1682 22.3058 10.7029 22.3062H22.1607C22.6954 22.3058 23.218 22.1469 23.6625 21.8496C24.1069 21.5523 24.4533 21.13 24.6579 20.636C24.8624 20.142 24.916 19.5984 24.8118 19.0739C24.7076 18.5495 24.4503 18.0677 24.0724 17.6894L22.3669 15.9838V12.9351C22.3669 11.361 21.7416 9.85138 20.6286 8.73834C19.5155 7.6253 18.0059 7 16.4318 7ZM22.748 19.0138C22.8641 19.13 22.9431 19.278 22.9751 19.4391C23.0072 19.6002 22.9907 19.7672 22.9279 19.919C22.865 20.0707 22.7586 20.2005 22.6221 20.2918C22.4855 20.3831 22.325 20.4319 22.1607 20.432H10.7029C10.5387 20.4319 10.3781 20.3831 10.2416 20.2918C10.1051 20.2005 9.99864 20.0707 9.9358 19.919C9.87296 19.7672 9.8565 19.6002 9.88852 19.4391C9.92053 19.278 9.99958 19.13 10.1157 19.0138L12.371 16.7585V12.9351C12.371 11.8581 12.7988 10.8252 13.5604 10.0636C14.3219 9.30207 15.3548 8.87423 16.4318 8.87423C17.5088 8.87423 18.5417 9.30207 19.3033 10.0636C20.0648 10.8252 20.4927 11.8581 20.4927 12.9351V16.7585L22.748 19.0138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9307 24.4927H13.9327V26.3669H18.9307V24.4927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8aed1b7a19aee042227c3d496d84f2fa.svg";
export { ForwardRef as ReactComponent };